export function debug(...args) {
    var _a;
    if (!window.test &&
        ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('MANAGER_TRACKING_DEBUG'))) {
        console.debug(...args);
    }
}
export const isEmpty = (obj) => {
    if ((obj === null || obj === void 0 ? void 0 : obj.length) || (obj === null || obj === void 0 ? void 0 : obj.size))
        return false;
    if (typeof obj !== 'object')
        return true;
    return !Object.values(obj).length;
};
export const capitalize = (str) => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
};
export const mapValues = (obj, fn) => Object.fromEntries(Object.entries(obj).map(([key, val]) => [key, fn(val, key, obj)]));
export const getRandomString = (len) => {
    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return new Array(len)
        .map(() => alphabet.charAt(Math.floor(Math.random() * alphabet.length)))
        .join('');
};
export const getUniqueId = () => {
    return new Date().valueOf().toString(36) + getRandomString(8);
};
//# sourceMappingURL=utils.js.map